import React from 'react';
import OrderConfirmation from './OrderConfirmation';
export default function OrdersTrack(props) { return <OrderConfirmation {...props}/>; }
